import {PictureLandmarkService} from './picture-landmark.service';
import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {ViewComponent} from '../../view.component';

@Component({
    selector: 'surface-picture-landmark',
    templateUrl: './picture-landmark.component.html',
    styleUrls: ['./picture-landmark.component.css']
})
export class PictureLandmarkComponent implements AfterViewInit, OnDestroy {

    @ViewChild('surfaceView') surfaceView: ViewComponent;

    constructor(public pictureLandmarkService: PictureLandmarkService) {
    }

    ngAfterViewInit(): void {
        this.pictureLandmarkService.initializeLandmarkView(this.surfaceView);
    }

    ngOnDestroy(): void {
        if (!this.pictureLandmarkService.imageActive) {
            // all landmarks placed -> align
            this.pictureLandmarkService.finishLandmarkPlacement();
        } else {
            // landmark placement aborted
            this.pictureLandmarkService.abortLandmarkPlacement();
        }
    }

}
